var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3231 55.2478C42.8923 55.2478 53.8924 44.2478 53.8924 30.6786C53.8924 17.1094 42.8923 6.10938 29.3231 6.10938C15.7539 6.10938 4.75391 17.1094 4.75391 30.6786C4.75391 44.2478 15.7539 55.2478 29.3231 55.2478Z",
    stroke: "#1D1D1F",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5231 22.506L26.1076 43.6444L20.2462 38.6444L20.2616 38.629L13.3999 32.7982L17.4307 28.1676L25.4 34.8445L38.7691 18.8906L43.5231 22.506Z",
    fill: "#1D1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/Check-circle.1ea475f47ce099d66218472a3bea5a49.svg";
export { ForwardRef as ReactComponent };